/* eslint-disable semi,semi-style */
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './app';
import useSign from '@/util/sign';
useSign();

const container = document.getElementById('root');
if (container) {
  createRoot(container).render(<App />);
}
